import { deleteRequest, get, post} from './_defaults/fetch.js';

export const getUsers = (params, config) => get('/users', {params, ...config});
export const getUser = ({id, params, config}) => get(`/users/${id}`, {params, ...config});
export const createUser = (body, config) => post('/users', body, config);
export const updateUser = ({id, data, config}) => post(`/users/${id}`, data, config);
export const deleteUser = (id, config) => deleteRequest(`/users/${id}`, null, config);
export const getUserPermissions = ({id, params, config}) => get(`/users/${id}/permissions`, {params, ...config});

